import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import router from '@/router';
import ArrowRightOutlined from '@/icons/ArrowRightOutlined.vue';
import { Row, Col } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CmsMenu',
  props: {
    menuData: { required: false },
},
  setup(__props) {



const isSettingsHomepage = computed(() => router.currentRoute.name === 'settings');

return { __sfc: true,isSettingsHomepage, ArrowRightOutlined, Row, Col }
}

})